import React from "react";

import styles from "./ErrorPage.module.scss";

import { Link } from "react-router-dom";

function ErrorPage() {
  return (
    <div className={styles.errorPage}>
      <h1>Belə bir səhifə tapılmadı...</h1>
      <p>
        <Link to="/ana-sehife"> Ana səhifəyə</Link>qayıt.
      </p>
    </div>
  );
}

export default ErrorPage;
